import styled from "styled-components";
import { Box, Flex, Text } from "rebass";

export const ModalContainer = styled(Box)`
  background: ${({ theme }) => theme.colors.navy600};
  border-radius: 16px;
  max-width: 500px;
  width: 90vw;
`;

export const ModalHeader = styled(Flex)`
  align-items: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.colors.navy50};
  justify-content: space-between;
  padding: 20px 24px;
`;

export const HeaderContent = styled(Box)`
  flex: 1;
  min-width: 0;
  padding-right: 16px;
`;

export const HeaderTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const ClipName = styled.span`
  color: ${({ theme }) => theme.colors.envy};
  font-weight: 700;
`;

export const HeaderSubtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  line-height: 1.4;
`;

export const ModalTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 18px;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  transition: all 0.15s ease;
  width: 32px;

  &:hover {
    background: ${({ theme }) => theme.colors.navy50};
    color: ${({ theme }) => theme.colors.ice};
  }
`;

export const ModalBody = styled(Box)`
  padding: 24px;
`;

export const ModalFooter = styled(Flex)`
  border-top: 1px solid ${({ theme }) => theme.colors.navy200};
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px;
`;

export const BodyText = styled(Text)`
  color: ${({ theme }) => theme.colors.shade200};
  font-family: Barlow;
  font-size: 15px;
  line-height: 1.5;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.colors.envy};
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  cursor: pointer;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  transition: opacity 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.navy200};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.shade100};
  cursor: pointer;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 24px;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.shade300};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const StorageBarContainer = styled(Box)`
  margin: 20px 0;
`;

export const StorageBarWrapper = styled(Box)`
  background: ${({ theme }) => theme.colors.navy};
  border-radius: 6px;
  height: 8px;
  overflow: hidden;
  width: 100%;
`;

export const StorageBarFill = styled(Box)<{
  $percentage: number;
  $isFull?: boolean;
}>`
  background: ${({ theme, $isFull }) =>
    $isFull ? theme.colors.alert : theme.colors.envy};
  border-radius: 6px;
  height: 100%;
  transition: width 0.3s ease;
  width: ${({ $percentage }) => Math.min($percentage, 100)}%;
`;

export const StorageText = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 13px;
  margin-top: 10px;
`;

export const UpgradeCard = styled(Box)`
  background: ${({ theme }) => theme.colors.navy};
  border-radius: 10px;
  margin-top: 24px;
  padding: 16px;
`;

export const UpgradeCardTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.shade200};
  font-family: Barlow;
  font-size: 14px;
  margin-bottom: 12px;
`;

export const UpgradeButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.envy};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.envy};
  cursor: pointer;
  font-family: Barlow;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 20px;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.envy};
    color: ${({ theme }) => theme.colors.midnight};
  }
`;

export const SuccessIcon = styled(Box)`
  align-items: center;
  background: ${({ theme }) => theme.colors.envy}20;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.envy};
  display: flex;
  height: 64px;
  justify-content: center;
  margin: 0 auto 20px;
  width: 64px;
`;

export const SuccessTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: center;
`;

export const SuccessSubtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  text-align: center;
`;

export const OptionCard = styled(Box)`
  background: ${({ theme }) => theme.colors.navy};
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 16px;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.envy};
  }
`;

export const OptionTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
`;

export const OptionDescription = styled(Text)`
  color: ${({ theme }) => theme.colors.shade400};
  font-family: Barlow;
  font-size: 13px;
`;

export const LoadingContainer = styled(Flex)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 48px 24px;
`;

export const LoadingText = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  margin-top: 16px;
`;
